import { CSSProperties } from 'react';
import { styled } from '@mui/material';

const UnstyledButton = styled('button')(({ props }: { props?: CSSProperties }) => ({
  display: 'flex',
  border: 'none',
  background: 'none',
  padding: '0',
  alignItems: 'center',
  justifyContent: 'center',
  ...(props ?? {})
}));

export default UnstyledButton;
